/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * A `fault_override_request_t` message is constructed and published with `enable`, `fault_id`,
 * and `override_value` fields.
 */
export interface SetFaultOverrideActionArgs {
  /** If true, the specified fault override is enabled. If false, the override is removed. */
  enable: boolean;
  /**
   * The fault ID. This is intentionally not `common.VehicleFault.Enum` out of a desire to not make
   * the mission spec dependent on faults.
   */
  faultId: number;
  /** The value to override the fault with. This is only used if `enable` is true. */
  overrideValue: boolean;
  /**
   * The fault name. This optional and has **no effect**; it is only meant to make the action args
   * more human readable in light of the fault ID just being an integer.
   */
  faultName: string;
  /** How long to wait for the override to take effect before timing out. Waits indefinitely if <= 0. */
  waitForOverrideTimeoutS: number;
}

export interface SetFaultOverrideResultData {
}

export interface SetFaultOverrideActionStateData {
}

function createBaseSetFaultOverrideActionArgs(): SetFaultOverrideActionArgs {
  return { enable: false, faultId: 0, overrideValue: false, faultName: "", waitForOverrideTimeoutS: 0 };
}

export const SetFaultOverrideActionArgs = {
  encode(message: SetFaultOverrideActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.enable === true) {
      writer.uint32(8).bool(message.enable);
    }
    if (message.faultId !== 0) {
      writer.uint32(16).int32(message.faultId);
    }
    if (message.overrideValue === true) {
      writer.uint32(24).bool(message.overrideValue);
    }
    if (message.faultName !== "") {
      writer.uint32(34).string(message.faultName);
    }
    if (message.waitForOverrideTimeoutS !== 0) {
      writer.uint32(45).float(message.waitForOverrideTimeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetFaultOverrideActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetFaultOverrideActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.enable = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.faultId = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.overrideValue = reader.bool();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.faultName = reader.string();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.waitForOverrideTimeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetFaultOverrideActionArgs {
    return {
      enable: isSet(object.enable) ? globalThis.Boolean(object.enable) : false,
      faultId: isSet(object.faultId) ? globalThis.Number(object.faultId) : 0,
      overrideValue: isSet(object.overrideValue) ? globalThis.Boolean(object.overrideValue) : false,
      faultName: isSet(object.faultName) ? globalThis.String(object.faultName) : "",
      waitForOverrideTimeoutS: isSet(object.waitForOverrideTimeoutS)
        ? globalThis.Number(object.waitForOverrideTimeoutS)
        : 0,
    };
  },

  toJSON(message: SetFaultOverrideActionArgs): unknown {
    const obj: any = {};
    if (message.enable === true) {
      obj.enable = message.enable;
    }
    if (message.faultId !== 0) {
      obj.faultId = Math.round(message.faultId);
    }
    if (message.overrideValue === true) {
      obj.overrideValue = message.overrideValue;
    }
    if (message.faultName !== "") {
      obj.faultName = message.faultName;
    }
    if (message.waitForOverrideTimeoutS !== 0) {
      obj.waitForOverrideTimeoutS = message.waitForOverrideTimeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetFaultOverrideActionArgs>, I>>(base?: I): SetFaultOverrideActionArgs {
    return SetFaultOverrideActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetFaultOverrideActionArgs>, I>>(object: I): SetFaultOverrideActionArgs {
    const message = createBaseSetFaultOverrideActionArgs();
    message.enable = object.enable ?? false;
    message.faultId = object.faultId ?? 0;
    message.overrideValue = object.overrideValue ?? false;
    message.faultName = object.faultName ?? "";
    message.waitForOverrideTimeoutS = object.waitForOverrideTimeoutS ?? 0;
    return message;
  },
};

function createBaseSetFaultOverrideResultData(): SetFaultOverrideResultData {
  return {};
}

export const SetFaultOverrideResultData = {
  encode(_: SetFaultOverrideResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetFaultOverrideResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetFaultOverrideResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetFaultOverrideResultData {
    return {};
  },

  toJSON(_: SetFaultOverrideResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetFaultOverrideResultData>, I>>(base?: I): SetFaultOverrideResultData {
    return SetFaultOverrideResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetFaultOverrideResultData>, I>>(_: I): SetFaultOverrideResultData {
    const message = createBaseSetFaultOverrideResultData();
    return message;
  },
};

function createBaseSetFaultOverrideActionStateData(): SetFaultOverrideActionStateData {
  return {};
}

export const SetFaultOverrideActionStateData = {
  encode(_: SetFaultOverrideActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetFaultOverrideActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetFaultOverrideActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetFaultOverrideActionStateData {
    return {};
  },

  toJSON(_: SetFaultOverrideActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetFaultOverrideActionStateData>, I>>(base?: I): SetFaultOverrideActionStateData {
    return SetFaultOverrideActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetFaultOverrideActionStateData>, I>>(_: I): SetFaultOverrideActionStateData {
    const message = createBaseSetFaultOverrideActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
